/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Raw, RawFromJSON, RawToJSON } from './Raw'
import { Webhook, WebhookFromJSON, WebhookToJSON } from './Webhook'

/**
 *
 * @export
 * @interface GetWebhookResponse
 */
export interface GetWebhookResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof GetWebhookResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof GetWebhookResponse
   */
  status: string
  /**
   *
   * @type {Webhook}
   * @memberof GetWebhookResponse
   */
  data: Webhook
  /**
   *
   * @type {Raw}
   * @memberof GetWebhookResponse
   */
  _raw?: Raw | null
}

export function GetWebhookResponseFromJSON(json: any): GetWebhookResponse {
  return GetWebhookResponseFromJSONTyped(json, false)
}

export function GetWebhookResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetWebhookResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    data: WebhookFromJSON(json['data']),
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function GetWebhookResponseToJSON(value?: GetWebhookResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    data: WebhookToJSON(value.data),
    _raw: RawToJSON(value._raw)
  }
}
